<template>
  <div class="w12 deposit-proof-page">
    <div v-if="step1.show" class="w12 p12">
      <ul class="modal_list1">
        <div class="title">{{ $t("uploadRemit.title") }}</div>
        <li class="mt20">
          {{ $t("uploadRemit.description[0]") }}
          <br /><br />
          {{ $t("uploadRemit.description[1]") }}
        </li>
        <li>
          <p>{{ $t("uploadRemit.howto.title") }}</p>
          {{ $t("uploadRemit.howto.content[0]") }}<br />
          {{ $t("uploadRemit.howto.content[1]") }}
        </li>
      </ul>
      <p class="modal_tit mt40">
        [{{ $t("uploadRemit.certification.title") }}]
      </p>
      <ul class="modal_list2">
        <li>
          <div class="bold">
            1. {{ $t("uploadRemit.certification.content[0].title") }}
          </div>
          <ul class="mt5">
            <li>
              - {{ $t("uploadRemit.certification.content[0].content[0]") }}
            </li>
            <li>
              - {{ $t("uploadRemit.certification.content[0].content[1]") }}
            </li>
          </ul>
        </li>
        <li class="mt20">
          <div class="bold">
            2. {{ $t("uploadRemit.certification.content[2].title") }}
          </div>
          <ul class="mt5">
            <li>
              - {{ $t("uploadRemit.certification.content[2].content[0]") }}
            </li>
            <li>
              <strong
                >-
                {{
                  $t("uploadRemit.certification.content[2].content[1]")
                }}</strong
              >
            </li>
            <li>
              - {{ $t("uploadRemit.certification.content[2].content[2]") }}
            </li>
            <li>
              {{ $t("uploadRemit.certification.content[2].content[3]") }}
            </li>
          </ul>
        </li>
      </ul>
      <div class="w12 button-box mt40">
        <button class="next" @click="showStep2">
          {{ $t("uploadRemit.next") }}
        </button>
      </div>
    </div>
    <div v-else class="w12 kyc-auth-content">
      <div class="title mt20">{{ $t("uploadRemitNext.title") }}</div>
      <p class="content-title">
        아래 내용에 따라 인증서류를 등록해 주세요.
      </p>
      <div class="w12 tip mt16 mb30 pl10">
        {{ $t("verificationReset.residence.notice") }}
      </div>
      <div class="w12 content-box">
        <p class="content-title">
          1. {{ $t("uploadRemit.certification.content[0].title") }}
        </p>
        <div class="form-box w12">
          <div class="w12" flex>
            <el-input
              size="mini"
              :placeholder="$t('uploadRemitNext.upload')"
              :value="step2.files.idCard.name"
            ></el-input>
            <input
              type="file"
              name="idCard"
              ref="idCardImg"
              @change="setFile"
              style="display: none"
            />
            <button
              class="black"
              size="small"
              type="primary"
              @click="$refs.idCardImg.click()"
            >
              {{ $t("verificationReset.residence.findFile") }}
            </button>
          </div>
          <div class="img-box">
            <ul>
              <li v-html="$t('uploadRemitNext.content[0][0]')"></li>
              <li v-html="$t('uploadRemitNext.content[0][1]')"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="w12 content-box">
        <p class="content-title">
          2. 1. {{ $t("uploadRemit.certification.content[2].title") }}
        </p>
        <div class="form-box w12">
          <div class="w12" flex>
            <el-input
              size="mini"
              :placeholder="$t('uploadRemitNext.upload')"
              :value="step2.files.address.name"
            ></el-input>
            <input
              type="file"
              name="address"
              ref="addressImg"
              @change="setFile"
              style="display: none"
            />
            <button
              class="black"
              size="small"
              type="primary"
              @click="$refs.addressImg.click()"
            >
              {{ $t("verificationReset.residence.findFile") }}
            </button>
          </div>
          <div class="img-box">
            <ul>
              <li v-html="$t('uploadRemitNext.content[2][0]')"></li>
              <li v-html="$t('uploadRemitNext.content[2][1]')"></li>
              <li v-html="$t('uploadRemitNext.content[2][2]')"></li>
              <li v-html="$t('uploadRemitNext.content[2][3]')"></li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 알리 리캡챠 -->
      <allibaba
        @send-response-data-event="getResponseData"
        ref="alibaba"
        :swapVisible="false"
        class="recaptcha"
      ></allibaba>
      <div class="w12 mt30" flex>
        <button class="cancel" @click="$router.push('/mypage/certification')">
          {{ $t("confirm.cancel") }}
        </button>
        <button class="submit" :disabled="!step2Complete" @click="requestRemit">
          {{ $t("uploadRemitNext.submit") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/common/Api";
import allibaba from "../../../components/login/allibaba";

export default {
  components: {
    allibaba,
  },
  props: ["show"],
  data() {
    return {
      step1: {
        show: true,
      },
      step2: {
        show: false,
        files: {
          idCard: {},
          address: {},
        },
      },
      ali_response: null,
    };
  },
  computed: {
    step2Complete() {
      const files = this.step2.files;
      return _.every(files, (file) => file.size);
    },
    files() {
      return [this.step2.files.idCard, this.step2.files.address];
    },
  },
  methods: {
    reset() {
      if (this.$refs.registScroll) this.$refs.registScroll.scrollTop = 0;
      if (this.$refs.uploadScroll) this.$refs.uploadScroll.scrollTop = 0;
      Object.assign(this.$data, this.$options.data());
      this.$emit("toggle", false);
      this.$refs.alibaba.aliSlideReset();
    },
    showStep2() {
      this.step1.show = false;
      this.step2.show = true;
    },
    setFile($event) {
      const { name, files } = $event.target;
      if (!files.length) {
        return false;
      }
      // size 체크
      const fileMaxSize = 10485760;
      if (
        files[0].size > fileMaxSize ||
        !/\.(jpg|jpeg|png)$/i.test(files[0].name)
      ) {
        this.$vs.notify({
          text: this.$t("verificationReset.residence.messageNotice"),
          color: "danger",
          position: "top-left",
        });
        return false;
      }
      this.step2.files[name] = files[0];
    },
    requestRemit() {
      if (!this.step2Complete) {
        return false;
      }
      console.log(this.ali_response);
      // 알리슬라이드 완료 확인
      if (this.ali_response == null) {
        this.$vs.notify({
          text: "Please verify the slide.",
          color: "danger",
          position: "top-left",
        });
        return false;
      }
      const { ali_token, ali_sig, ali_csessionid } = this.ali_response
        ? this.ali_response
        : {};

      // this.onUpload = true;
      Api.Transfer.confirmRemittance([...this.files], {
        ali_token,
        ali_sig,
        ali_csessionid,
      })
        .then((response) => {
          this.$vs.notify({
            title: "전송 완료",
            text: "송금확인증 등록이 완료되었습니다.",
            position: "top-left",
          });
          // this.reset();
          this.$router.push("/mypage/certification");
        })
        .catch((e) => {
          this.$vs.notify({
            title: "전송 실패",
            text: e.msg,
            color: "danger",
            position: "top-left",
          });
        })
        .finally(() => {
          // this.onUpload = false;
        });
    },
    getResponseData(data) {
      console.log(data);
      // data = rcapt_id || ali_response
      if (!isNaN(data)) {
        this.rcapt_id = data;
        this.ali_response = null;
      } else {
        this.rcapt_id = null;
        this.ali_response = data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recaptcha {
  margin-top: 20px;
}
</style>
